import {PermissionGroup} from '../../../shared-components/security/permission-group.model';

export class NotificationGroupPermissionGroup {

    // Server Properties
    ID: number;
    NotificationGroup_ID: number;
    GroupPermissions_ID: number;
    AddedOn: Date;
    AddedBy: number;
    LastUpdatedOn: Date;
    LastUpdatedBy: number;
    PermissionGroup: PermissionGroup;

    // Constructors
    constructor(
        notificationGroupId?: number,
        groupPermissionsId?: number
    ) {
        this.NotificationGroup_ID = notificationGroupId;
        this.GroupPermissions_ID = groupPermissionsId;
    }
}
